export const siteInfo = {
  name: '虫虫漫画网',
  slogan: '随时随地，漫画随行',
  h1: '虫虫漫画网 - 免费漫画在线阅读平台',
  intro: '虫虫漫画网是国内领先的免费看漫画网站，专注为漫画爱好者提供海量免费漫画资源。平台涵盖韩漫、日漫、国漫三大品类，支持全集漫画下拉式阅读，无需翻页即可畅快追更。无论你是喜欢热血冒险、甜蜜恋爱还是悬疑推理，这里都有好看的漫画推荐等你发现。每日更新、实时上架，让你不错过任何一部精彩作品。',
  stats: [
    { value: '10万+', label: '漫画资源' },
    { value: '每日更新', label: '持续上架' },
    { value: '永久免费', label: '无需付费' },
  ],
};

export const topics = [
  { id: 't1', name: '热血少年', heat: '98.6万', color: 'primary' },
  { id: 't2', name: '恋爱甜宠', heat: '87.3万', color: 'accent' },
  { id: 't3', name: '悬疑推理', heat: '72.1万', color: 'secondary' },
  { id: 't4', name: '奇幻冒险', heat: '65.8万', color: 'primary' },
  { id: 't5', name: '都市职场', heat: '58.4万', color: 'accent' },
  { id: 't6', name: '古风仙侠', heat: '53.2万', color: 'secondary' },
  { id: 't7', name: '搞笑日常', heat: '49.7万', color: 'primary' },
  { id: 't8', name: '科幻未来', heat: '44.5万', color: 'accent' },
  { id: 't9', name: '校园青春', heat: '41.2万', color: 'secondary' },
  { id: 't10', name: '治愈温馨', heat: '38.9万', color: 'primary' },
];

export const indexCollections = [
  {
    id: 'i1',
    title: '韩漫精选合集',
    count: 2860,
    description: '精选高人气韩漫作品，画风精致剧情在线',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20with%20vibrant%20colors%20and%20dynamic%20character%20poses%2C%20romance%20fantasy%20theme%2C%20clean%20modern%20digital%20art%20aesthetic%2C%20soft%20warm%20lighting%2C%20Korean%20manhwa%20cover%20art%20inspired%20composition%2C%20elegant%20character%20design%2C%20pastel%20color%20palette%20with%20golden%20accents%2C%20beautiful%20decorative%20elements&width=800&height=600&seq=comic-index-01&orientation=landscape',
    tag: '韩漫',
  },
  {
    id: 'i2',
    title: '日漫经典殿堂',
    count: 5420,
    description: '收录经典与热门日漫，重温那些年追过的番',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20featuring%20adventure%20and%20action%20themes%2C%20dynamic%20panel%20composition%2C%20black%20and%20white%20manga%20aesthetic%20with%20color%20accents%2C%20shonen%20style%20character%20art%2C%20dramatic%20lighting%2C%20clean%20linework%2C%20professional%20illustration%20quality&width=800&height=600&seq=comic-index-02&orientation=landscape',
    tag: '日漫',
  },
  {
    id: 'i3',
    title: '国漫崛起力作',
    count: 3180,
    description: '优质国产漫画，东方美学与现代叙事的完美融合',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20traditional%20Chinese%20ink%20painting%20influence%2C%20xianxia%20cultivation%20theme%2C%20flowing%20robes%20and%20ancient%20architecture%2C%20watercolor%20texture%2C%20ethereal%20atmosphere%2C%20elegant%20composition%2C%20modern%20digital%20art%20with%20classical%20aesthetic&width=800&height=600&seq=comic-index-03&orientation=landscape',
    tag: '国漫',
  },
  {
    id: 'i4',
    title: '下拉式阅读专区',
    count: 8900,
    description: '专为手机优化的长条漫画，一滑到底畅快阅读',
    image: 'https://readdy.ai/api/search-image?query=Modern%20vertical%20scroll%20webtoon%20style%20illustration%2C%20continuous%20storytelling%20format%2C%20colorful%20digital%20comic%20panels%2C%20smooth%20gradient%20backgrounds%2C%20mobile-friendly%20reading%20aesthetic%2C%20bright%20and%20engaging%20visual%20style%2C%20clean%20modern%20design&width=800&height=600&seq=comic-index-04&orientation=landscape',
    tag: '下拉式',
  },
  {
    id: 'i5',
    title: '本周热门推荐',
    count: 1560,
    description: '根据阅读热度实时更新，发现大家都在看的好漫画',
    image: 'https://readdy.ai/api/search-image?query=Trending%20popular%20comic%20illustration%20collage%2C%20multiple%20art%20styles%20blending%20together%2C%20vibrant%20warm%20colors%2C%20eye-catching%20composition%2C%20fire%20and%20flame%20motifs%2C%20dynamic%20energy%2C%20modern%20digital%20art%2C%20exciting%20visual%2C%20clean%20background&width=800&height=600&seq=comic-index-05&orientation=landscape',
    tag: '热门',
  },
  {
    id: 'i6',
    title: '新作抢先看',
    count: 890,
    description: '第一时间上架新番漫画，做第一批追更的读者',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20new%20comic%20release%20themed%20illustration%20with%20sparkling%20new%20badge%2C%20clean%20modern%20art%20style%2C%20bright%20hopeful%20color%20palette%2C%20ribbon%20and%20celebration%20elements%2C%20excited%20character%20expression%2C%20soft%20gradient%20background%2C%20warm%20inviting%20atmosphere&width=800&height=600&seq=comic-index-06&orientation=landscape',
    tag: '新作',
  },
  {
    id: 'i7',
    title: '完结漫画库',
    count: 4230,
    description: '已完结经典漫画一次看个够，无需等待更新',
    image: 'https://readdy.ai/api/search-image?query=Complete%20finished%20comic%20collection%20illustration%2C%20bookshelf%20with%20colorful%20comic%20volumes%2C%20warm%20cozy%20atmosphere%2C%20library%20aesthetic%2C%20golden%20complete%20stamp%2C%20organized%20clean%20layout%2C%20satisfying%20visual%2C%20soft%20ambient%20lighting%2C%20rich%20color%20variety&width=800&height=600&seq=comic-index-07&orientation=landscape',
    tag: '完结',
  },
];

export const updates = [
  { id: 'u1', date: '07-29', title: '《暗夜追踪者》第128话更新', summary: '真相逐渐浮出水面，主角面临关键抉择...', category: '悬疑推理' },
  { id: 'u2', date: '07-29', title: '《星海迷途》第三季正式上线', summary: '全新篇章开启，宇宙冒险再续前缘', category: '科幻未来' },
  { id: 'u3', date: '07-28', title: '《甜蜜陷阱》第56话甜蜜来袭', summary: '告白名场面来袭，甜度爆表的一话', category: '恋爱甜宠' },
  { id: 'u4', date: '07-28', title: '《剑道无双》突破1000万阅读', summary: '国漫之光再创佳绩，感谢读者支持', category: '国漫' },
  { id: 'u5', date: '07-27', title: '《异世界食堂》第二季连载开始', summary: '人气美食漫画回归，治愈你的胃和心', category: '治愈温馨' },
  { id: 'u6', date: '07-27', title: '全网首发《末日幸存者》外传篇', summary: '虫虫漫画独家首发，外传剧情同样精彩', category: '奇幻冒险' },
  { id: 'u7', date: '07-26', title: '暑期档特别企划：校园漫画周', summary: '十大校园漫画限时免费读，青春不散场', category: '校园青春' },
  { id: 'u8', date: '07-26', title: '《古剑奇谭》漫画版正式授权上线', summary: '经典游戏IP漫画化，原汁原味还原剧情', category: '古风仙侠' },
];

export const features = [
  { id: 'f1', icon: 'ri-book-read-line', title: '下拉式阅读', description: '专为移动端优化的纵向阅读模式，一气呵成无需翻页，沉浸式漫画体验' },
  { id: 'f2', icon: 'ri-global-line', title: '海量正版漫画', description: '韩漫、日漫、国漫三大品类全覆盖，10万+漫画资源持续扩充中' },
  { id: 'f3', icon: 'ri-flashlight-line', title: '永久免费', description: '所有漫画免费阅读，无需会员付费，人人平等的漫画阅读体验' },
  { id: 'f4', icon: 'ri-time-line', title: '实时更新提醒', description: '关注的漫画更新第一时间推送，不错过任何精彩剧情的推进' },
];

export const mediaItems = [
  {
    id: 'm1',
    title: '《暗夜追踪者》PV预告',
    views: '126万',
    category: '悬疑推理',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20noir%20themed%20comic%20promotional%20illustration%2C%20shadowy%20urban%20night%20scene%2C%20detective%20silhouette%2C%20dramatic%20lighting%20contrast%2C%20cinematic%20composition%2C%20cold%20blue%20and%20warm%20amber%20color%20contrast%2C%20mysterious%20atmosphere%2C%20high%20quality%20digital%20art&width=800&height=500&seq=comic-media-01&orientation=landscape',
    playIcon: true,
  },
  {
    id: 'm2',
    title: '《星海迷途》动画化决定',
    views: '98万',
    category: '科幻未来',
    image: 'https://readdy.ai/api/search-image?query=Space%20sci-fi%20adventure%20comic%20illustration%20with%20colorful%20nebula%20and%20starship%2C%20futuristic%20aesthetic%2C%20bright%20nebulae%20colors%2C%20dynamic%20space%20battle%20scene%2C%20cinematic%20wide%20angle%2C%20epic%20scale%2C%20professional%20animation-style%20art&width=800&height=500&seq=comic-media-02&orientation=landscape',
    playIcon: true,
  },
  {
    id: 'm3',
    title: '虫虫漫画创作者访谈特辑',
    views: '75万',
    category: '幕后故事',
    image: 'https://readdy.ai/api/search-image?query=Comic%20artist%20studio%20workspace%20illustration%2C%20drawing%20tablet%20and%20sketchbooks%2C%20warm%20creative%20atmosphere%2C%20art%20supplies%20scattered%2C%20cozy%20lighting%2C%20behind%20the%20scenes%20vibe%2C%20creative%20process%20visual%2C%20professional%20digital%20art%20workspace&width=800&height=500&seq=comic-media-03&orientation=landscape',
    playIcon: true,
  },
  {
    id: 'm4',
    title: '暑期漫画阅读马拉松活动',
    views: '63万',
    category: '活动',
    image: 'https://readdy.ai/api/search-image?query=Summer%20reading%20festival%20themed%20comic%20illustration%2C%20colorful%20celebration%20atmosphere%2C%20books%20and%20summer%20elements%2C%20beach%20and%20sunny%20background%2C%20fun%20vibrant%20colors%2C%20festive%20decorations%2C%20joyful%20mood%2C%20clean%20modern%20digital%20art%20style&width=800&height=500&seq=comic-media-04&orientation=landscape',
    playIcon: true,
  },
];

export const contactInfo = {
  title: '联系我们',
  description: '商务合作、版权授权、创作投稿、意见建议，欢迎通过以下方式与我们取得联系。虫虫漫画网期待与更多优秀的漫画创作者和合作伙伴携手同行。',
  email: 'contact@chongchongcomic.com',
  wechat: '虫虫漫画官方',
  weibo: '@虫虫漫画网',
};

export const aboutInfo = {
  title: '关于虫虫漫画网',
  content: '虫虫漫画网成立于2020年，致力于打造国内优质的免费漫画阅读平台。我们与国内外多家漫画工作室和版权方合作，为用户提供海量正版漫画内容。平台采用先进的下拉式阅读技术，让漫画阅读更加流畅自然。\n\n我们的团队由一群热爱漫画的年轻人组成，从产品设计到内容运营，每个环节都倾注了对漫画的热爱。我们相信，好的漫画应该被更多人看到，阅读漫画不应该有门槛。\n\n未来，虫虫漫画网将继续拓展内容品类，优化阅读体验，支持更多原创漫画作者，为中国的漫画文化发展贡献力量。',
  stats: [
    { value: '10万+', label: '漫画资源' },
    { value: '5000万+', label: '月活读者' },
    { value: '300+', label: '合作作者' },
  ],
};

export const appInfo = {
  title: '虫虫漫画 App',
  description: '下载虫虫漫画App，享受更流畅的下拉式阅读体验。支持离线下载、夜间模式、个性化推荐等功能，让漫画随时随地陪伴你。',
  features: ['离线下载随时看', '夜间模式护眼读', '个性化智能推荐', '多设备同步进度'],
  qrImage: 'https://readdy.ai/api/search-image?query=Clean%20QR%20code%20mockup%20design%20with%20cartoon%20mascot%2C%20modern%20app%20download%20page%20style%2C%20warm%20orange%20and%20white%20color%20scheme%2C%20simple%20minimal%20design%2C%20phone%20mockup%20with%20comic%20app%20screen%2C%20friendly%20cute%20branding&width=300&height=300&seq=comic-app-qr&orientation=squarish',
};

export const faqItems = [
  {
    id: 'faq1',
    question: '虫虫漫画网真的完全免费吗？',
    answer: '是的，虫虫漫画网所有漫画内容永久免费阅读。我们通过广告和品牌合作维持运营，不会向读者收取任何费用。注册账号后还可以享受书签收藏、阅读历史同步等更多免费功能。',
  },
  {
    id: 'faq2',
    question: '什么是下拉式阅读？',
    answer: '下拉式阅读是专为移动端设计的漫画阅读方式，所有内容纵向排列，读者只需向下滑动即可连续阅读，无需点击翻页按钮。这种方式特别适合手机阅读，让漫画浏览更加流畅自然。',
  },
  {
    id: 'faq3',
    question: '支持哪些平台的漫画？',
    answer: '目前虫虫漫画网支持韩漫、日漫和国漫三大品类。我们与国内外多家版权方合作，持续扩充漫画资源库，确保读者能够看到最新最全的漫画内容。',
  },
  {
    id: 'faq4',
    question: '如何找到我想看的漫画？',
    answer: '你可以通过首页的分类标签、排行榜、专题合集来发现漫画，也可以使用搜索功能直接查找作品名称或作者。我们还提供个性化推荐功能，根据你的阅读偏好智能推荐你可能喜欢的漫画。',
  },
  {
    id: 'faq5',
    question: '我是漫画创作者，如何与虫虫漫画网合作？',
    answer: '欢迎原创漫画作者与我们合作！请通过联系我们页面的投稿邮箱发送作品样章和简介，我们的内容团队会在7个工作日内进行审核回复。虫虫漫画网为原创作者提供有竞争力的分成方案和流量扶持。',
  },
];

export const cards = [
  {
    id: 'c1',
    title: '暗夜追踪者',
    description: '都市暗处隐藏着不为人知的秘密，天才侦探与神秘组织展开一场猫鼠游戏...',
    tag: '悬疑推理',
    heat: '128万',
    image: 'https://readdy.ai/api/search-image?query=Noir%20detective%20comic%20illustration%20with%20urban%20night%20setting%2C%20shadowy%20figure%20in%20trench%20coat%2C%20neon%20lights%20reflection%2C%20dramatic%20contrast%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20dark%20alley%20scene%2C%20professional%20digital%20art&width=600&height=400&seq=comic-card-01&orientation=landscape',
  },
  {
    id: 'c2',
    title: '甜蜜陷阱',
    description: '当高冷总裁遇上呆萌实习生，一场意外不断的办公室恋情就此展开...',
    tag: '恋爱甜宠',
    heat: '115万',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20comic%20illustration%20with%20office%20setting%2C%20couple%20moment%20with%20sparkling%20effect%2C%20warm%20pink%20and%20peach%20color%20palette%2C%20chibi%20style%20characters%2C%20flower%20petals%20falling%2C%20sweet%20atmosphere%2C%20clean%20cheerful%20digital%20art&width=600&height=400&seq=comic-card-02&orientation=landscape',
  },
  {
    id: 'c3',
    title: '剑道无双',
    description: '少年背负家族使命踏入修仙之路，一剑破万法，逆天改命的传奇故事...',
    tag: '古风仙侠',
    heat: '102万',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20cultivation%20comic%20illustration%2C%20swordsman%20on%20mountain%20peak%2C%20flowing%20ancient%20robes%2C%20dramatic%20clouds%20and%20mist%2C%20traditional%20Chinese%20architecture%20background%2C%20dynamic%20sword%20energy%2C%20epic%20atmosphere%2C%20ink%20wash%20painting%20influence&width=600&height=400&seq=comic-card-03&orientation=landscape',
  },
  {
    id: 'c4',
    title: '末日幸存者',
    description: '末日降临，文明崩塌，普通大学生如何在废土世界中寻找希望与同伴...',
    tag: '奇幻冒险',
    heat: '96万',
    image: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20adventure%20comic%20illustration%2C%20ruined%20cityscape%20background%2C%20survivor%20characters%20in%20wasteland%2C%20warm%20sunset%20lighting%2C%20dramatic%20sky%2C%20gritty%20but%20hopeful%20atmosphere%2C%20detailed%20environment%20art%2C%20professional%20digital%20illustration&width=600&height=400&seq=comic-card-04&orientation=landscape',
  },
  {
    id: 'c5',
    title: '异世界食堂',
    description: '在异世界开一家温暖的餐厅，用美食治愈每一位旅人的心灵和胃...',
    tag: '治愈温馨',
    heat: '89万',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20fantasy%20restaurant%20comic%20illustration%2C%20warm%20interior%20with%20steaming%20food%2C%20friendly%20characters%20dining%2C%20golden%20soft%20lighting%2C%20homey%20atmosphere%2C%20delicious%20food%20presentation%2C%20heartwarming%20scene%2C%20clean%20wholesome%20digital%20art&width=600&height=400&seq=comic-card-05&orientation=landscape',
  },
];

export const carouselItems = [
  {
    id: 'cl1',
    title: '暑期漫画大赏',
    subtitle: '百部精选漫画限时推荐',
    description: '炎炎夏日，虫虫漫画为你精选100部高人气漫画，涵盖热血、恋爱、悬疑、奇幻等全品类，这个暑假不剧荒！',
    tag: '特别企划',
    image: 'https://readdy.ai/api/search-image?query=Summer%20comic%20festival%20themed%20wide%20banner%20illustration%2C%20colorful%20summer%20elements%20with%20watermelons%20and%20fireworks%2C%20multiple%20anime-style%20characters%20celebrating%2C%20vibrant%20warm%20colors%2C%20festive%20atmosphere%2C%20clean%20gradient%20background%2C%20horizontal%20banner%20composition%2C%20eye-catching%20design&width=1200&height=500&seq=comic-carousel-01&orientation=landscape',
  },
  {
    id: 'cl2',
    title: '韩漫新浪潮',
    subtitle: '探索韩国漫画的无限可能',
    description: '从浪漫爱情到悬疑惊悚，韩国漫画以其独特的叙事和精致的画风征服全球读者，一起来感受韩漫的魅力。',
    tag: '韩漫专区',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20wide%20illustration%20with%20elegant%20character%20portraits%2C%20soft%20pastel%20color%20scheme%2C%20romantic%20and%20dramatic%20composition%2C%20modern%20fashion%20design%2C%20clean%20sophisticated%20aesthetic%2C%20glamorous%20atmosphere%2C%20horizontal%20layout%2C%20professional%20digital%20art&width=1200&height=500&seq=comic-carousel-02&orientation=landscape',
  },
  {
    id: 'cl3',
    title: '国漫之光',
    subtitle: '见证中国漫画的崛起之路',
    description: '从水墨风到现代数字绘画，国漫正在用独特的东方美学征服世界。虫虫漫画网持续收录优质国漫作品，与你共同见证。',
    tag: '国漫专区',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20themed%20wide%20banner%20illustration%2C%20traditional%20Chinese%20aesthetic%20with%20modern%20twist%2C%20ink%20painting%20style%20landscape%2C%20flowing%20silk%20ribbons%2C%20golden%20and%20red%20color%20palette%2C%20epic%20scale%2C%20cultural%20elements%2C%20horizontal%20composition%2C%20dramatic%20lighting&width=1200&height=500&seq=comic-carousel-03&orientation=landscape',
  },
  {
    id: 'cl4',
    title: '日漫经典回顾',
    subtitle: '重温那些年我们一起追的漫画',
    description: '从少年Jump到少女漫画，日本漫画陪伴了几代人的成长。虫虫漫画网整理经典日漫合集，带你找回最初的感动。',
    tag: '日漫专区',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20classic%20themed%20wide%20illustration%2C%20nostalgic%20shonen%20style%20art%2C%20action%20scene%20with%20dynamic%20speed%20lines%2C%20vibrant%20colors%2C%20friendship%20and%20adventure%20themes%2C%20dramatic%20composition%2C%20warm%20nostalgic%20atmosphere%2C%20horizontal%20layout&width=1200&height=500&seq=comic-carousel-04&orientation=landscape',
  },
  {
    id: 'cl5',
    title: '新人作者扶持计划',
    subtitle: '虫虫漫画助力原创梦想起航',
    description: '我们相信每一个漫画梦想都值得被看见。虫虫漫画网推出新人作者扶持计划，为原创漫画作者提供流量和资源支持。',
    tag: '原创扶持',
    image: 'https://readdy.ai/api/search-image?query=Creative%20artist%20support%20themed%20wide%20illustration%2C%20young%20artist%20drawing%20at%20desk%2C%20inspirational%20atmosphere%2C%20warm%20sunlight%20through%20window%2C%20sketchbooks%20and%20art%20tools%2C%20hopeful%20and%20motivating%20mood%2C%20clean%20bright%20digital%20art%2C%20horizontal%20banner&width=1200&height=500&seq=comic-carousel-05&orientation=landscape',
  },
];

export const comments = [
  {
    id: 'cm1',
    name: '漫画迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20profile%20avatar%20of%20a%20young%20person%2C%20round%20icon%20style%2C%20warm%20friendly%20expression%2C%20simple%20clean%20background%2C%20soft%20colors%2C%20cartoon%20portrait%2C%20minimal%20design&width=100&height=100&seq=comic-avatar-01&orientation=squarish',
    date: '2026-07-28',
    content: '虫虫漫画真的是我用过的最好用的免费漫画网站！下拉式阅读太方便了，躺床上看漫画再也不用费劲翻页了。漫画资源也多，韩漫日漫国漫都有，推荐给身边所有喜欢看漫画的朋友了！',
    rating: 5,
  },
  {
    id: 'cm2',
    name: '追漫小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20female%20profile%20avatar%2C%20round%20icon%20style%2C%20cheerful%20smiling%20expression%2C%20simple%20clean%20background%2C%20warm%20colors%2C%20cartoon%20portrait%2C%20minimal%20design&width=100&height=100&seq=comic-avatar-02&orientation=squarish',
    date: '2026-07-27',
    content: '之前用过好几个漫画APP都要收费或者看广告看到烦，虫虫漫画真的良心！永久免费不是说说而已。而且更新速度也很快，基本上热门漫画当天就能看到最新话。',
    rating: 5,
  },
  {
    id: 'cm3',
    name: '资深二次元',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20male%20profile%20avatar%2C%20round%20icon%20style%2C%20confident%20expression%2C%20simple%20clean%20background%2C%20warm%20dark%20colors%2C%20cartoon%20portrait%2C%20minimal%20design&width=100&height=100&seq=comic-avatar-03&orientation=squarish',
    date: '2026-07-26',
    content: '从日本留学回来之后一直想找能看日漫原版的地方，虫虫漫画的日漫区做得真不错。国漫也在崛起，最近看了几部国产漫画质量超乎预期，推荐大家都来支持国漫！',
    rating: 4,
  },
  {
    id: 'cm4',
    name: '通勤漫画人',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20anime%20style%20female%20profile%20avatar%2C%20round%20icon%20style%2C%20gentle%20smile%20expression%2C%20simple%20clean%20background%2C%20soft%20warm%20colors%2C%20cartoon%20portrait%2C%20minimal%20design&width=100&height=100&seq=comic-avatar-04&orientation=squarish',
    date: '2026-07-25',
    content: '每天上下班路上都在虫虫漫画看漫画，下拉式阅读单手操作超方便。离线下载功能也很实用，地铁里信号不好的时候也能看。推荐异世界食堂和甜蜜陷阱，超好看！',
    rating: 5,
  },
];

export const rankingItems = [
  {
    id: 'r1',
    rank: 1,
    title: '暗夜追踪者',
    author: '墨鱼工作室',
    heat: '128万',
    category: '悬疑推理',
    trend: 'up',
    image: 'https://readdy.ai/api/search-image?query=Noir%20mystery%20comic%20cover%20style%20illustration%2C%20dark%20urban%20night%2C%20detective%20silhouette%2C%20dramatic%20lighting%2C%20neon%20accents%2C%20cinematic%20portrait%20ratio%2C%20clean%20composition%2C%20professional%20digital%20art&width=400&height=280&seq=comic-rank-01&orientation=landscape',
  },
  {
    id: 'r2',
    rank: 2,
    title: '甜蜜陷阱',
    author: '糖果工坊',
    heat: '115万',
    category: '恋爱甜宠',
    trend: 'up',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20comic%20cover%20style%2C%20couple%20portrait%2C%20pink%20cherry%20blossom%20background%2C%20sparkling%20effects%2C%20sweet%20atmosphere%2C%20clean%20composition%2C%20professional%20digital%20art&width=400&height=280&seq=comic-rank-02&orientation=landscape',
  },
  {
    id: 'r3',
    rank: 3,
    title: '剑道无双',
    author: '青云漫画',
    heat: '102万',
    category: '古风仙侠',
    trend: 'stable',
    image: 'https://readdy.ai/api/search-image?query=Xianxia%20comic%20cover%20style%2C%20swordsman%20with%20flowing%20robes%2C%20mountain%20mist%20background%2C%20traditional%20Chinese%20aesthetic%2C%20dramatic%20composition%2C%20professional%20digital%20art&width=400&height=280&seq=comic-rank-03&orientation=landscape',
  },
  {
    id: 'r4',
    rank: 4,
    title: '末日幸存者',
    author: '极光画室',
    heat: '96万',
    category: '奇幻冒险',
    trend: 'up',
    image: 'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20comic%20cover%20style%2C%20survivor%20in%20wasteland%2C%20ruined%20city%20silhouette%2C%20warm%20sunset%20lighting%2C%20dramatic%20sky%2C%20professional%20digital%20art&width=400&height=280&seq=comic-rank-04&orientation=landscape',
  },
  {
    id: 'r5',
    rank: 5,
    title: '异世界食堂',
    author: '暖心漫画',
    heat: '89万',
    category: '治愈温馨',
    trend: 'up',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20fantasy%20food%20comic%20cover%20style%2C%20warm%20restaurant%20interior%2C%20steaming%20food%20closeup%2C%20golden%20lighting%2C%20inviting%20atmosphere%2C%20professional%20digital%20art&width=400&height=280&seq=comic-rank-05&orientation=landscape',
  },
  {
    id: 'r6',
    rank: 6,
    title: '星海迷途',
    author: '银河舰队',
    heat: '83万',
    category: '科幻未来',
    trend: 'down',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20space%20comic%20cover%20style%2C%20starship%20in%20colorful%20nebula%2C%20futuristic%20aesthetic%2C%20epic%20scale%2C%20bright%20nebula%20colors%2C%20professional%20digital%20art&width=400&height=280&seq=comic-rank-06&orientation=landscape',
  },
];